import Box from '@material-ui/core/Box'
import { L10n, loadCldr } from '@syncfusion/ej2-base'
import { AnimatePresence, motion } from 'framer-motion'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  caGregorian,
  l10n,
  numberingSystems,
  numbers,
  timeZoneNames,
} from './Scheduler'
import Login from './components/Login'
import Navbar from './components/Navbar'
import RouterContainer from './components/RouterContainer'
import Sidebar from './components/Sidebar'
import useNotifier from './hooks/useNotifier'
import useTypedSelector from './hooks/useTypedSelector'
import { startSession } from './store/session/sessionActions'
import { StoreState } from 'store'
import { UserAlerts } from 'pages/UserAlerts'

// Calendar language setting
loadCldr(numberingSystems, numbers, caGregorian, timeZoneNames)
L10n.load(l10n)

export default function App() {
  const [server, setServer] = useState('prod')

  const { logged, loadingSession } = useTypedSelector(({ sessionState }) => ({
    loadingSession: sessionState.loadingSession,
    logged: sessionState.logged,
  }))

  const dispatch = useDispatch()

  const Server = () => {
    fetch(`${process.env.REACT_APP_HOST_APY_REST}/settings`)
      .then((response) => response.json())
      .then((data) => setServer(data.server))
      .catch((error) => console.log(error))
  }

  useNotifier()

  const { alertsUser } = useSelector(({ alertsUserState }: StoreState) => ({
    alertsUser: alertsUserState.alertsUser,
  }))

  const alertsUserExist = alertsUser.find(
    (item) => item.name === 'termos' && item.status === 'pending'
  )

  useEffect(() => {
    dispatch(startSession())
    Server()
  }, [dispatch])

  if (loadingSession) {
    return null
  }

  if (logged && alertsUserExist) {
    return <UserAlerts id={alertsUserExist.id} />
  }

  return (
    <AnimatePresence exitBeforeEnter>
      <div>
        {server === 'development' ? (
          <>
            <div className="tag-vertical">
              <span className="tag-text">Development</span>
            </div>
          </>
        ) : (
          <></>
        )}
        {!logged ? (
          <Login key="login" />
        ) : (
          <motion.div
            key="main"
            initial={{ opacity: 0, scale: 0.7 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.7 }}
            transition={{ duration: 0.2 }}
          >
            <Navbar />

            <Box display="flex">
              <Sidebar />

              <RouterContainer />
            </Box>
          </motion.div>
        )}
      </div>
    </AnimatePresence>
  )
}
